import { Button, Table } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React from 'react';

const FieldsTable = ({ fields, loading }) => {
  const expandedRowRender = field => {
    const data = field.nested.map(el => {
      return {
        key: el.name,
        name: el.name,
        description: el.description,
      };
    });

    const columns = [
      {
        title: 'Nested Field Name',
        dataIndex: 'name',
        key: 'nested-field-name',
      },
      {
        title: 'Nested Field Description',
        dataIndex: 'description',
        key: 'nested-field-description',
      },
    ];
    return <Table columns={columns} dataSource={data} pagination={false} />;
  };

  return (
    <Table
      style={{ marginTop: 10 }}
      columns={[
        {
          title: 'Name',
          dataIndex: 'name',
        },
        {
          title: 'Description',
          dataIndex: 'description',
        },
      ]}
      rowKey="id"
      pagination={false}
      loading={loading}
      dataSource={fields}
      expandable={{
        expandedRowRender,
        rowExpandable: record => record.nested && record.nested.length > 0,
        // eslint-disable-next-line react/no-unstable-nested-components
        expandIcon: ({ expanded, onExpand, record }) =>
          record.nested && record.nested.length > 0 ? (
            <Button
              size="small"
              onClick={e => onExpand(record, e)}
              type="primary"
              data-cy={`toggle-nested-fields-${record.name}`}
            >
              {expanded ? 'Hide' : 'Show'} Nested Fields{' '}
              {expanded ? <UpOutlined /> : <DownOutlined />}
            </Button>
          ) : null,
      }}
    />
  );
};

export default FieldsTable;
